import { defineComponent as _defineComponent } from 'vue'
import CardExpand from '@/views/components/CardExpand.vue';
import { mdiInformation } from '@mdi/js';
import AutocompleteGraphql from '@/views/components/autocompletes/AutocompleteGraphql.vue';
import {
  GET_BOLETINS,
  GET_CARTORIOS,
  GET_CLASSES,
  GET_COMARCAS,
  GET_PROLATORES,
  GET_RELATORES,
  GET_VARAS,
} from '@/queries';
import { ConsultaJurisprudenciaSelecionadaStore } from '../../store/ConsultaJurisprudenciaSelecionadaStore';
import { storeToRefs } from 'pinia';
import { useLazyQuery } from '@vue/apollo-composable';
import { onMounted, ref } from 'vue';
import { IBoletim } from '@/views/boletins/types';

interface IProps {
  expandido?: boolean;
}

interface IEmits {
  (event: 'change:expandido', e: boolean): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardMaisFiltros',
  props: {
    expandido: { type: Boolean }
  },
  emits: ["change:expandido"],
  setup(__props: any) {





const store = ConsultaJurisprudenciaSelecionadaStore();

const { filtroJurisprudencia } = storeToRefs(store);

const tiposBoletins = ref<IBoletim[]>([]);

const buscaInicialTiposBoletins = async () => {
  const { load, variables } = useLazyQuery(GET_BOLETINS);
  variables.value = { nmTipoBoletim: '' };
  tiposBoletins.value = (await load()).tipoBoletins;
};

onMounted(() => {
  buscaInicialTiposBoletins();
});

return { __sfc: true,store, filtroJurisprudencia, tiposBoletins, buscaInicialTiposBoletins, CardExpand, mdiInformation, AutocompleteGraphql, GET_BOLETINS, GET_CARTORIOS, GET_CLASSES, GET_COMARCAS, GET_PROLATORES, GET_RELATORES, GET_VARAS }
}

})